import Mirador from 'mirador/dist/es/src/index';
import { miradorImageToolsPlugin } from 'mirador-image-tools';
import miradorDownloadPlugins from 'mirador-dl-plugin';
import textOverlayPlugin from 'mirador-textoverlay';

if (process.env.NODE_ENV !== 'production') {
   console.log('Looks like we are in development mode!');
 }

function createMiradorViewer(config) {
  return Mirador.viewer(config, [
  ...miradorImageToolsPlugin, miradorDownloadPlugins, textOverlayPlugin
]);
}

export { createMiradorViewer, };